import React from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  pri: '#0a0e27',
  pri2: '#2952CC',
  accent: '#6382eb',
  accent2: '#4f6ef2',
  bg: '#f7f8fc',
  white: '#FFFFFF',
  text: '#444',
  muted: '#666',
  border: '#eef0f5',
  green: '#10b981',
  red: '#ea4335',
  yellow: '#f59e0b',
  purple: '#8b5cf6',
};

const S = {
  wrapper: {
    minHeight: '100vh',
    fontFamily: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
    background: C.bg,
  },
  header: {
    background: `linear-gradient(135deg,${C.pri} 0%,#111c4e 50%,#1a2f7a 100%)`,
    padding: '48px 20px 64px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  backBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    color: 'rgba(255,255,255,0.70)',
    textDecoration: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    position: 'relative',
    zIndex: 1,
    marginBottom: '24px',
    background: 'none',
    border: 'none',
    padding: '0',
  },
  h1: {
    fontSize: 'clamp(28px,4vw,44px)',
    fontWeight: 800,
    color: C.white,
    margin: '0 0 12px',
    position: 'relative',
    zIndex: 1,
  },
  sub: {
    fontSize: '16px',
    color: 'rgba(255,255,255,0.55)',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: 1.7,
    position: 'relative',
    zIndex: 1,
  },
  body: { maxWidth: '900px', margin: '0 auto', padding: '48px 20px 80px' },
  card: {
    background: C.white,
    borderRadius: '16px',
    padding: '32px',
    border: `1px solid ${C.border}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    marginBottom: '24px',
  },
  h2: { fontSize: '22px', fontWeight: 700, color: C.pri, margin: '0 0 8px' },
  cardText: { fontSize: '15px', color: C.muted, lineHeight: 1.7 },
  grid2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
    marginTop: '20px',
  },
  grid3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '12px',
    marginTop: '20px',
  },
  miniCard: {
    background: C.bg,
    borderRadius: '12px',
    padding: '20px',
    border: `1px solid ${C.border}`,
  },
  miniH3: { fontSize: '16px', fontWeight: 700, color: C.pri, margin: '0 0 6px' },
  miniP: { fontSize: '14px', color: C.muted, lineHeight: 1.6 },
  badge: (bg, c) => ({
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '8px',
    background: bg,
    color: c,
    fontSize: '11px',
    fontWeight: 700,
    marginLeft: '8px',
    verticalAlign: 'middle',
  }),
};

function InventarioDetalle() {
  const nav = useNavigate();
  return (
    <div style={S.wrapper}>
      <style>{'body{overflow:auto!important}'}</style>
      <div style={S.header}>
        <button onClick={() => nav('/#inventario')} style={S.backBtn}>
          &#8592; Volver al inicio
        </button>
        <h1 style={S.h1}>Inventario Inteligente y Sincronización</h1>
        <p style={S.sub}>
          Dashboard de alertas, vista por sede, exportación Excel y sincronización en tiempo real
          con tu base de datos externa.
        </p>
      </div>
      <div style={S.body}>
        <div style={S.card}>
          <h2 style={S.h2}>Dashboard de Inventario</h2>
          <p style={S.cardText}>
            Al abrir el panel de inventario, ves de inmediato un resumen con métricas clave:
          </p>
          <div style={S.grid3}>
            {[
              {
                icon: '\uD83D\uDCE6',
                t: 'Total Productos',
                d: 'Cantidad total de productos en el catálogo maestro.',
                c: C.pri2,
              },
              {
                icon: '\u274C',
                t: 'Agotados (stock=0)',
                d: 'Productos sin existencia. Requieren reposicion urgente.',
                c: C.red,
              },
              {
                icon: '\u26A0',
                t: 'Stock Negativo',
                d: 'Posible error, robo o merma no reportada. Alerta inmediata.',
                c: C.yellow,
              },
              {
                icon: '\uD83D\uDD14',
                t: 'Por Agotarse (stock\u22645)',
                d: 'Alerta temprana para hacer pedido a proveedores.',
                c: '#6366f1',
              },
              {
                icon: '\u2696',
                t: 'Productos Pesables',
                d: 'Cuantos productos se venden por peso (kg, g, lb).',
                c: C.purple,
              },
              {
                icon: '\uD83D\uDCC2',
                t: 'Departamentos',
                d: 'Cantidad de categorías o departamentos distintos.',
                c: C.accent,
              },
            ].map((x, i) => (
              <div key={i} style={{ ...S.miniCard, textAlign: 'center' }}>
                <div style={{ fontSize: '28px', marginBottom: '8px' }}>{x.icon}</div>
                <h3 style={{ ...S.miniH3, color: x.c }}>{x.t}</h3>
                <p style={S.miniP}>{x.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Vista por Sede</h2>
          <p style={S.cardText}>
            Puedes ver el inventario de una sede especifica o la vista consolidada de todas las
            sedes. En la vista consolidada, cada producto muestra su stock desglosado por sucursal
            en columnas individuales.
          </p>
          <p style={S.cardText}>
            <strong>Filtros disponibles:</strong> busqueda por texto, ordenamiento por cualquier
            columna (precio, stock, departamento, marca), filtro por estado (todos, agotados,
            negativos, al dia, pesables).
          </p>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Exportación a Excel</h2>
          <p style={S.cardText}>
            Exporta tu inventario completo a un archivo Excel (.xlsx) con un solo clic. El archivo
            incluye:
          </p>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {[
              'Formato profesional con auto-filtros en cada columna',
              'Paneles congelados para scroll sin perder los encabezados',
              'Columnas de stock por cada sucursal',
              'Precios formateados como moneda',
              'Listo para enviar a proveedores o contabilidad',
            ].map((li, i) => (
              <li
                key={i}
                style={{
                  ...S.cardText,
                  padding: '6px 0',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <span style={{ color: C.green, fontWeight: 700 }}>&#10003;</span> {li}
              </li>
            ))}
          </ul>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>
            Sincronización en Tiempo Real
            <span style={S.badge('#ecfdf5', C.green)}>DESTACADO</span>
          </h2>
          <p style={S.cardText}>
            Agorax se conecta directamente a la base de datos de tu negocio. Si ya tienes un sistema
            (ERP, SQL Server, etc.), el módulo de sincronización importa automáticamente tu catálogo
            de productos, precios y stock.
          </p>
          <div style={S.grid2}>
            {[
              {
                t: 'Conexión directa',
                d: 'Se configura la conexión a tu base de datos externa (SQL Server via pyodbc). Los datos se sincronizan periódicamente.',
              },
              {
                t: 'Historial de cambios',
                d: 'Cada modificación de precio o stock queda registrada: valor anterior, nuevo valor, fecha, sede y lote de sincronización.',
              },
              {
                t: 'Sin duplicación',
                d: 'El sistema detecta productos existentes y solo actualiza los campos que cambiaron. Nuevos productos se agregan automáticamente.',
              },
              {
                t: 'Carga masiva de imágenes',
                d: 'Sube un ZIP con imágenes de productos organizadas por sede. El sistema las asocia automáticamente por código.',
              },
            ].map((x, i) => (
              <div key={i} style={S.miniCard}>
                <h3 style={S.miniH3}>{x.t}</h3>
                <p style={S.miniP}>{x.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Auditoria de Cambios</h2>
          <p style={S.cardText}>
            Cada vez que un precio o stock cambia (ya sea por sincronización externa o manualmente),
            el sistema registra:
          </p>
          <div
            style={{
              ...S.miniCard,
              background: '#fffbeb',
              border: '1px solid #fde68a',
              marginTop: '12px',
            }}
          >
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                'Precio anterior → Precio nuevo',
                'Stock anterior → Stock nuevo',
                'Fecha y hora exacta del cambio',
                'Sede afectada',
                'Lote de sincronización (batch ID)',
              ].map((li, i) => (
                <li
                  key={i}
                  style={{
                    fontSize: '14px',
                    color: C.text,
                    padding: '4px 0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <span style={{ color: C.yellow, fontWeight: 700 }}>&#9679;</span> {li}
                </li>
              ))}
            </ul>
          </div>
          <p style={{ ...S.cardText, marginTop: '12px' }}>
            Esto permite identificar exactamente cuando y como cambio cada dato. Ideal para
            auditoria, control de mermas y toma de decisiones.
          </p>
        </div>
        <button
          onClick={() => nav('/#inventario')}
          style={{
            ...S.backBtn,
            color: C.pri2,
            display: 'block',
            margin: '0 auto',
            fontSize: '16px',
            fontWeight: 600,
          }}
        >
          &#8592; Volver al inicio
        </button>
      </div>
    </div>
  );
}

export default InventarioDetalle;
